import { MutationTree } from 'vuex';
import { ChannelState, PaginationInfo } from './state';

const mutations: MutationTree<ChannelState> = {
  SET_FORUM_API_CHANNELS(state, entities: ChannelState) {
    if (!entities.channels) {
      state.channels = {};
      return;
    }

    state.channels = entities.channels;
  },
  SET_FORUM_API_PAGINATION_INFO(state, data: PaginationInfo) {
    state.pagination = data;
  },
};

export default mutations;
